import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";
// import Export from "../../component/Export";

const ViewSection = () => {
  const [loading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const sectionsRef = useRef([]);
  sectionsRef.current = sections;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}section`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSections(data.data);

        //  ------For TableViewer ------
        const sectionsData = data.data.map((section) => ({
          section: section.class + " - " + section.section,
          idNumber: section.sectionid,
        }));
        setRowData(sectionsData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  }, [token]);

  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () =>
    sections.map((section) => {
      return {
        section: section.section,
        class: section.class,
      };
    });

  // ------------------------------------------------------------------ edit Section -----------------------------------------------------U
  const handleEditBtn = (id) => {
    navigate(`/addsection/${btoa(encodeURIComponent(id))}`);
  };

  // ------------------------------------------------------------------ Delete Section -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete section. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    console.log(id);
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}section/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          console.log("Response:", response);

          return response.json();
        })
        .then(function (data) {
          console.log("Data:", data);

          if (data.status === 200) {
            triggerNotification("success", "Section deleted successfully");

            //  ------For TableViewer ------
            const updatedSections = [...sectionsRef.current];
            updatedSections.splice(i, 1);
            setSections(updatedSections);
            const sectionsData = updatedSections.map((section) => ({
              section: section.class + " - " + section.section,
              idNumber: section.sectionid,
            }));
            setRowData(sectionsData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "Section not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting Section");
        });
    };
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "section", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Section" subpath={["View Sections"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Sections</h5>
            <div>
              {/* <Export onExport={handleExport} /> */}
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addsection");
                }}
              >
                Add Section
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="justify-center px-3 pb-3 row mx-4 select-none">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewSection;
